import { Injectable } from '@angular/core';
import { NetworkService } from 'src/app/core/services/network.service';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { DataService } from 'src/app/shared/services/data.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SELECTED_FACTORY } from 'src/app/app.contant';

@Injectable({
  providedIn: 'root'
})
export class RequesterService {

  constructor(
    private networkService: NetworkService,
    private utilSer: UtilsService,
    private dataSer: DataService
  ) { }

  setPointsAsOutliers(points: any[], item, comment, userDtls) {
    const data = {
      Tag: item.tagname,
      MyEpochs: points.map(pt => pt.tsEpoch),
      Comment: comment,
      UserId: userDtls.username,
      UserName: userDtls.name //profile.given_name + ' ' + userDtls.profile.family_name
    };
    const url = item.batch === '1' ? 'AddOultiersToBatchSensorData' : 'AddOultiersToSensorData';

    return this.networkService.httpReq('post', 'SPCAPI', url, data, false);
  }

  setPointsAsOutliersQtyOne(points: any[], item: any, comment: string, userDtls: any) {
    const data = {
      CharacteristicMasterId: item.characteristicid,
      MyEpochs: points.map((pt: any) => {
        return { Epoch: pt.tsEpoch, TestResultQuantitativeData: pt.value };
      }),
      Comment: comment,
      UserId: userDtls.username,
      UserName: userDtls.name
    };
    const url = 'AddOultiersToQuantitativeData';
    return this.networkService.httpReq('post', 'SPCAPI', url, data, false);
  }

  public removeManualOutliers(points: any[], item: any, userDtls: any): Observable<any> {
    const data = {
      Tag: item.tagname,
      MyEpochs: points.map(pt => pt.tsEpoch),
      UserId: userDtls.username,
      UserName: userDtls.name //given_name + ' ' + userDtls.profile.family_name
    };
    const url = item.batch === '1' ? 'RemoveOultiersFromBatchSensorData' : 'RemoveOultiersFromSensorData';
    return this.networkService.httpReq('post', 'SPCAPI', url, data, false);
  }

  public removeQualityOneManualOutliers(points: any[], item: any, userDtls: any): Observable<any> {
    const data = {
      CharacteristicMasterId: item ? item.id : '',
      MyEpochs: points.map((pt: any) => {
        return { Epoch: pt.tsEpoch, TestResultQuantitativeData: pt.value };
      }),
      UserId: userDtls.username,
      UserName: userDtls.name
    };
    const url = 'RemoveOultiersFromQuantitativeData';
    return this.networkService.httpReq('post', 'SPCAPI', url, data, false);
  }

  public getQualityOneTimeSeriesData(ch: any, form: any, time: any, IsHistogram = false): Observable<any> {
    const factory = this.dataSer.getStorageData(SELECTED_FACTORY);
    const factoryId = factory ? JSON.parse(factory).factoryId : null;
    const f = form;
    const SupplierMasterId = f && f.supplier ? f.supplier.suppliermasterid : null;
    const CharacteristicMasterId = ch && ch.characteristicid ? ch.characteristicid : null;
    const StartTimeEpoch = time ? Math.floor((+time.from) / 1000) : null;
    const EndTimeEpoch = time ? Math.floor((+time.to) / 1000) : null;
    const pageRange = '0-299';
    const IsFiftyPoints = false;

    const data = { factoryId, SupplierMasterId, CharacteristicMasterId, StartTimeEpoch, EndTimeEpoch, pageRange, IsHistogram, IsFiftyPoints };
    // return this.networkService.httpReq('get', 'SPCAPI', 'GetProcessCapabilityTimeSeriesChart', data, false)
    return this.networkService.httpReq('get', 'SPCAPI', 'GetCharacteresticProcessChart', data, false)
      .pipe(map((res: any) => {
        return res ? res : [];
      }));
  }

  // tslint:disable-next-line: max-line-length
  getTimeSeriesData(
    paramDtls,
    timeDtls,
    skuDtls,
    lineDtls,
    customTimeDtls,
    loaderNeeded = true,
    trend = false,
    capability = null,
    chartFirstIndex?,
    chartLastIndex?,
    skuRunPeriod?: any,
    factoryDtls = null
  ) {
    const now = new Date();
    let hitURL = '';

    let isBatchParam = false;
    if (paramDtls.batch === '1' || paramDtls.batch === 'True') {
      isBatchParam = true;
    }

    const data: any = {
      TagName: paramDtls.tagname,
      factoryId: factoryDtls ? factoryDtls.factoryId : (this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null),
      LineId: lineDtls.id,
      Id: paramDtls.id
    };

    if (skuDtls && (skuDtls.skuId || skuDtls.id)) {
      if (skuDtls.skuId) {
        data.SkuId = skuDtls.skuId;
      } else {
        data.SkuId = skuDtls.id;
      }
    }

    if ((timeDtls.value === 'last-45days') && (timeDtls.code === 'custom' || timeDtls.code === 'comparison-custom')) {
      data.IsHistorical = false;
    } else if (timeDtls.value === 'custom' || timeDtls.value === 'comparison-custom') {
      data.IsHistorical = true;
    }

    switch (timeDtls.code) {
      case 'hour':
        hitURL = !isBatchParam ? 'GetTimeSeriesChart' : 'GetBatchTimeSeriesChart';
        data.StartTimeEpoch = Math.floor((+now - (1000 * 60 * 60)) / 1000);
        data.EndTimeEpoch = Math.floor((+now) / 1000);
        break;
      case '50points':
        hitURL = !isBatchParam ? 'GetLastFiftyTimeSeriesDataPoints' : 'GetLastFiftyBatchTimeSeriesDataPoints';
        break;
      case 'custom':
        hitURL = !isBatchParam ? 'GetTimeSeriesChart' : 'GetBatchTimeSeriesChart';
        data.StartTimeEpoch = skuRunPeriod.respStartTS;
        data.EndTimeEpoch = skuRunPeriod.respEndTS;

        if (paramDtls.tagsku === 'Yes' && paramDtls.sku.length) {
          data.lsl = paramDtls.sku.filter(x => x.skuid === skuDtls.skuId)[0] ?
            paramDtls.sku.filter(x => x.skuid === skuDtls.skuId)[0].skulsl : null;
          data.usl = paramDtls.sku.filter(x => x.skuid === skuDtls.skuId)[0] ?
            paramDtls.sku.filter(x => x.skuid === skuDtls.skuId)[0].skuusl : null;
          data.targetValue = paramDtls.sku.filter(x => x.skuid === skuDtls.skuId)[0] ?
            paramDtls.sku.filter(x => x.skuid === skuDtls.skuId)[0].skutarget : null;
        } else {
          data.lsl = paramDtls.lsl;
          data.usl = paramDtls.usl;
          data.targetValue = paramDtls.targetvalue ? paramDtls.targetvalue : null;
        }
        if (paramDtls.isHistogram) {
          data.IsHistogram = true;
          data.pageRange = chartFirstIndex + '-' + chartLastIndex;
        } else {
          data.pageRange = chartFirstIndex + '-' + chartLastIndex;
          data.IsHistogram = false;
        }
        break;
      case 'comparison-custom':
        hitURL = !isBatchParam ? 'GetTimeSeriesChart' : 'GetBatchTimeSeriesChart';
        data.StartTimeEpoch = Math.floor(+customTimeDtls.from / 1000);
        data.EndTimeEpoch = Math.floor(+customTimeDtls.to / 1000) + 59;
        data.pageRange = chartFirstIndex + '-' + chartLastIndex;
        break;
    }
    if (trend) {
      const trendData: any = {
        TagNames: paramDtls.map(item => item.tagname)
      };
      if (timeDtls.code !== '50points') {
        trendData.starttime = data.StartTimeEpoch;
        trendData.endtime = data.EndTimeEpoch;
        if (timeDtls.code === 'comparison-custom') {
          trendData.PageRange = data.pageRange;
        }
      }
      if ((timeDtls.value === 'last-45days') && (timeDtls.code === 'custom' || timeDtls.code === 'comparison-custom')) {
        trendData.IsHistorical = false;
      } else if (timeDtls.value === 'custom' || timeDtls.value === 'comparison-custom') {
        trendData.IsHistorical = true;
      }
      return this.networkService.httpReq('post', 'SPCAPI', 'GetTrendChart', trendData, false, loaderNeeded);
    } else {
      if (hitURL === 'GetBatchTimeSeriesChart' || 'GetLastFiftyBatchTimeSeriesDataPoints') {
        data.dataSource = paramDtls.datasource ? paramDtls.datasource : null;
        data.machineName = paramDtls.machinename ? paramDtls.machinename : null;
      }
      if (capability && capability.type) {
        hitURL = +paramDtls.batch ? 'GetBatchXBarRChart' : 'GetTimeSeriesXBarRChart';
        data.SubgroupSize = capability.subgroupSize;
        data.IsRChart = capability.isRChart;
        data.IsIChart = false;
        data.OutlierFilter = capability.outlierType;
      } else {
        data.IsIChart = true;
      }
      return this.networkService.httpReq('get', 'SPCAPI', hitURL, data, false, loaderNeeded);
    }
  }

  getManualOultiers(tagname, timeEpoch, timePeriord) {
    // const data: any = {
    //   Tag: tagname,
    //   StartTimeEpoch: timeEpoch[0].tsEpoch,
    //   EndTimeEpoch: timeEpoch[timeEpoch.length - 1].tsEpoch
    // };
    const data: any = {
      Tag: tagname,
      StartTimeEpoch: timePeriord.startTime,
      EndTimeEpoch: timePeriord.endTime
    };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetManualOultiers', data, false);
  }

  public getManualOultiersQtyOne(tagname: any, timeEpoch: any) {
    const data: any = {
      CharacteristicMasterId: tagname,
      StartTimeEpoch: timeEpoch[0].tsEpoch,
      EndTimeEpoch: timeEpoch[timeEpoch.length - 1].tsEpoch
    };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetManualOultiersQuantitativeData', data, false);
  }

  GetSkuSpecificRunListBasedOnTimeRange(lineID, periodDtls, skuDtls, custDate?) {
    const data: any = {
      factoryId: this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
      LineId: lineID === 'ALL' ? '' : lineID,
      StartTimeEpoch: 0,
      EndTimeEpoch: 0,
      SkuId: skuDtls.skuId
    };
    if (periodDtls.code === 'custom') {
      data.StartTimeEpoch = Math.floor(+custDate.from / 1000);
      data.EndTimeEpoch = Math.floor(+custDate.to / 1000) + 59;
    }
    return this.networkService.httpReq('get', 'SPCAPI', 'GetSkuSpecificRunListBasedOnTimeRange', data, false);
  }

  // tslint:disable-next-line: max-line-length
  getTimeSeriesDataGA(
    paramDetails,
    timeDetails,
    skuDetails,
    lineDetails,
    factoryIDGA,
    customTimeDetails,
    loaderNeeded = true,
    chartFirstIndex?,
    chartLastIndex?,
    skuRunPeriod?: any) {
    const now = new Date();
    let hitURL = '';

    let isBatchParam = false;
    if (paramDetails.batch === '1') {
      isBatchParam = true;
    }

    const data: any = {
      TagName: paramDetails.tagname,
      factoryId: factoryIDGA ?
        factoryIDGA.factoryId : null,
      LineId: lineDetails.id,
      Id: paramDetails.id
    };

    if (skuDetails && (skuDetails.skuId || skuDetails.id)) {
      if (skuDetails.skuId) {
        data.SkuId = skuDetails.skuId;
      } else {
        data.SkuId = skuDetails.id;
      }
    }

    if (timeDetails.value === 'last-45days') {
      timeDetails.code = 'comparison-custom';
      data.IsHistorical = false;
    } else if (timeDetails.value === 'comparison-custom') {
      data.IsHistorical = true;
    }

    switch (timeDetails.code) {
      case '50points':
        hitURL = !isBatchParam ? 'GetLastFiftyTimeSeriesDataPoints' : 'GetLastFiftyBatchTimeSeriesDataPoints';
        break;
      case 'hour':
        hitURL = !isBatchParam ? 'GetTimeSeriesChart' : 'GetBatchTimeSeriesChart';
        data.StartTimeEpoch = Math.floor((+now - (1000 * 60 * 60)) / 1000);
        data.EndTimeEpoch = Math.floor((+now) / 1000);
        break;
      case 'custom':
        hitURL = !isBatchParam ? 'GetTimeSeriesChart' : 'GetBatchTimeSeriesChart';
        data.StartTimeEpoch = skuRunPeriod.respStartTS;
        data.EndTimeEpoch = skuRunPeriod.respEndTS;

        if (paramDetails.tagsku === 'Yes' && paramDetails.sku.length) {
          data.lsl = paramDetails.sku.filter(x => x.skuid === skuDetails.skuId)[0] ?
            paramDetails.sku.filter(x => x.skuid === skuDetails.skuId)[0].skulsl : null;
          data.usl = paramDetails.sku.filter(x => x.skuid === skuDetails.skuId)[0] ?
            paramDetails.sku.filter(x => x.skuid === skuDetails.skuId)[0].skuusl : null;
          data.targetValue = paramDetails.sku.filter(x => x.skuid === skuDetails.skuId)[0] ?
            paramDetails.sku.filter(x => x.skuid === skuDetails.skuId)[0].skutarget : null;
        } else {
          data.lsl = paramDetails.lsl;
          data.usl = paramDetails.usl;
          data.targetValue = paramDetails.targetvalue ? paramDetails.targetvalue : null;
        }
        data.pageRange = chartFirstIndex + '-' + chartLastIndex;
        break;
      case 'comparison-custom':
        hitURL = !isBatchParam ? 'GetTimeSeriesChart' : 'GetBatchTimeSeriesChart';
        data.StartTimeEpoch = Math.floor(+customTimeDetails.from / 1000);
        data.EndTimeEpoch = Math.floor(+customTimeDetails.to / 1000);
        data.pageRange = chartFirstIndex + '-' + chartLastIndex;
        break;
    }
    if (hitURL === 'GetBatchTimeSeriesChart' || 'GetLastFiftyBatchTimeSeriesDataPoints') {
      data.dataSource = paramDetails.datasource ? paramDetails.datasource : null;
      data.machineName = paramDetails.machinename ? paramDetails.machinename : null;
    }
    return this.networkService.httpReq('get', 'SPCAPI', hitURL, data, false, loaderNeeded);
  }

  // getcimalertnotification(res) {
  //   const data = {
  //     "usecaseids": [
  //       "1123277854300536835",
  //       "1123288113076568067"
  //     ],
  //     "alerttype": "ThresholdBreach",
  //     "hourlimit": 0,
  //     "factoryId": "A_3181",
  //     "StartEpoch": 1760258276,
  //     "EndEpoch": 1762936676
  //   }
  //   return this.networkService.httpReq('post', 'SPCAPICI', 'getcimalertnotification', data, false, true);

  // }
}
